module.exports = __webpack_public_path__ + "static/img/8083_phase_function_Paper_PointsHejduk_Prediction.3e580a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/8083_phase_function_Paper_PointsHejduk_Prediction.png
// module id = kmet
// module chunks = 0